import axios from "axios";

export const CREATE_INVOICE_RECEIPT = "/receipts/createInvoiceReceipt";
export const CREATE_RECEIPT = "/receipts/createReceipt";
export const UPLOAD_MULTI_AGENTS_FILE = "/receipts/uploadMultiAgentsFile";

export function findCustomerAgent(customerID, isAgent) {
  return axios.get(`/receipts/findCustomers?customerID=${customerID}&isAgent=${isAgent}`, {customerID});
}

export function createInvoiceReceiptNewAgent(data) {
  return axios.post(CREATE_INVOICE_RECEIPT, data);
}

export function createInvoiceReceiptExistingAgent(data) {
  return axios.post(CREATE_RECEIPT, data);
}

export function uploadMultiAgentsFile({formData}) {
  return axios.post(UPLOAD_MULTI_AGENTS_FILE, formData);
}

